import TableCell, { TableCellOptions } from '@tiptap/extension-table-cell';
import { ResourceType } from './types';
import { mergeAttributes } from '@tiptap/core';
import stColorToHex from './stColorToHex';

const contentExpr = {
  page: '(paragraph | bulletList | orderedList | taskList | heading | stImageGroup)+',
  comment: '(paragraph | bulletList | orderedList | taskList)+',
  card: '(paragraph | bulletList | orderedList | taskList | heading | stImageGroup)+',
  board: '(paragraph)+',
  note: '(paragraph | bulletList | orderedList | taskList | heading | stImageGroup)+',
};

export default TableCell.extend<TableCellOptions & { resourceType?: ResourceType }>({
  addOptions() {
    return {
      ...this.parent?.(),
      resourceType: undefined,
    };
  },
  addAttributes() {
    return {
      ...this.parent?.(),
      backgroundColor: {
        default: null,
        renderHTML: (attributes) => {
          /**
           * If there is a set custom Superthread colour (which is dark-mode friendly also),
           * ignore the backgroundColor attribute.
           */
          if (!attributes.backgroundColor || attributes.stTableColor) {
            return {};
          }

          return {
            style: `background-color: ${attributes.backgroundColor};`,
          };
        },
        parseHTML: (element) => {
          return element.style.backgroundColor?.replace?.(/['"]+/g, '') ?? null;
        },
      },
      stTableColor: {
        default: null,
        renderHTML: (attributes) => {
          if (!attributes.stTableColor) {
            return {};
          }

          const backgroundColor =
            stColorToHex[attributes.stTableColor as keyof typeof stColorToHex]?.light;

          const attrs: Record<string, any> = {
            'data-st-table-color': attributes.stTableColor,
          };

          if (backgroundColor) {
            attrs.style = `background-color: ${backgroundColor};`;
          }

          return attrs;
        },
        parseHTML: (element) => {
          return element.getAttribute('data-st-table-color');
        },
      },
    };
  },
  content() {
    if (!this.options.resourceType) {
      return '(paragraph)+';
    } else {
      return contentExpr[this.options.resourceType];
    }
  },
  renderHTML({ HTMLAttributes }) {
    return ['td', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
  },
});
